import { useState } from 'react'
import { useAdminData } from './hooks/useAdminData'
import { AuthOverlay } from './components/AuthOverlay'
import { Nav } from './components/Nav'
import { PatientModal } from './components/PatientModal'
import { Overview } from './components/sections/Overview'
import { KpiStrip } from './components/sections/KpiStrip'
import { Demographics } from './components/sections/Demographics'
import { Tiers } from './components/sections/Tiers'
import { Signals } from './components/sections/Signals'
import { Domains } from './components/sections/Domains'
import { Investigations } from './components/sections/Investigations'
import { Diagnoses } from './components/sections/Diagnoses'
import { CycleHealth } from './components/sections/CycleHealth'
import { Insights } from './components/sections/Insights'
import { Timeline } from './components/sections/Timeline'
import { Triage } from './components/sections/Triage'

export default function App() {
  const { data, generatedAt, isAuthed, error, loading, login, fetchPatient } = useAdminData()
  const [activePatientId, setActivePatientId] = useState<number | null>(null)

  if (!isAuthed) {
    return <AuthOverlay onLogin={login} error={error} loading={loading} />
  }

  return (
    <>
      <Nav />
      <div className="dash">
        <Overview data={data} generatedAt={generatedAt!} />
        <KpiStrip data={data} />
        <Demographics data={data} />
        <Tiers data={data} />
        <Signals data={data} />
        <Domains data={data} />
        <Investigations data={data} />
        <Diagnoses data={data} />
        <CycleHealth data={data} />
        <Insights data={data} />
        <Timeline data={data} />
        <Triage data={data} onContact={id => setActivePatientId(id)} />
        <footer className="dash-footer">
          fertilityawareness.ifsdnetwork.com · IFSD Network / FEMM Clinical Practice · Population Dashboard · n={data.length}
        </footer>
      </div>
      {activePatientId !== null && (
        <PatientModal
          submissionId={activePatientId}
          fetchPatient={fetchPatient}
          onClose={() => setActivePatientId(null)}
        />
      )}
    </>
  )
}
